import react from "react";
import { SectionCard } from "../../../Component/CustComponents/SectionCard";
import { Badge } from "../../../Component/CustComponents/Badge";
import { CheckCircle2 } from "lucide-react";

export default function CustLegalView() {
  return (
    <div className="space-y-4 p-2">
      <SectionCard title="Your Consents & Legal Documents">
        <div className="space-y-2 text-xs">
          <div className="flex items-center justify-between">
            <div>
              <div className="font-semibold text-slate-800">
                Warranty Terms & Conditions
              </div>
              <div className="text-[11px] text-slate-500">
                Accepted during warranty purchase
              </div>
            </div>
            <Badge color="green">
              <CheckCircle2 className="w-3 h-3 mr-1" />
              Accepted
            </Badge>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <div className="font-semibold text-slate-800">
                Privacy Policy / Data Consent
              </div>
              <div className="text-[11px] text-slate-500">
                Accepted while creating your customer account
              </div>
            </div>
            <Badge color="green">
              <CheckCircle2 className="w-3 h-3 mr-1" />
              Accepted
            </Badge>
          </div>

          <div className="pt-2 text-[11px] text-slate-500">
            You can read full documents and download copies for your records.
          </div>

          <div className="flex flex-wrap gap-2 pt-1">
            <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
              View Warranty Terms
            </button>
            <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
              View Privacy Policy
            </button>
            <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100">
              Download Summary PDF
            </button>
          </div>
        </div>
      </SectionCard>

      <SectionCard title="Important Warranty Rules">
        <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
          <li>
            Keep your invoice and device serial / IMEI number safely – they are
            required for claims.
          </li>
          <li>
            Physical or liquid damage is usually not covered, unless clearly
            mentioned in your plan.
          </li>
          <li>
            Claims must be raised while the warranty is Active and within the
            coverage period.
          </li>
          <li>
            Our team may contact you or visit your location for inspection if
            needed.
          </li>
        </ul>
      </SectionCard>
    </div>
  );
}